import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  Instrument,
  TariffStatus,
} from '@prlw/core/monitor/all-instruments.entity';
import { ForecastTrend } from '@prlw/core/monitor/forecast-trend.entity';
import { BasisDetailsInterface } from '../../basis-details.interface';
import { ModifierType } from '@prlw/core/monitor/types/common';

@Component({
  selector: 'prlw-all-table-tooltip-ui',
  templateUrl: './all-table-tooltip.component.html',
  styleUrls: ['./all-table-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AllTableTooltipComponent {
  @Input() public instrument!: Instrument;
  @Input() public modifierType!: ModifierType;
  public basisDetails: BasisDetailsInterface | null = null;

  public get isTariffAbsent(): boolean {
    return (
      (this.instrument.tariffStatus === TariffStatus.Wait ||
        this.instrument.tariffStatus === TariffStatus.TariffError) &&
      this.modifierType !== ModifierType.BASIC
    );
  }

  public get hasForecast(): boolean {
    return Boolean(this.instrument.forecast?.trend);
  }

  public get forecastDescription(): string {
    const description: { [key: string]: string } = {
      [ForecastTrend.Up]: 'Рост (более 250 \u20BD/т)',
      [ForecastTrend.Down]: 'Падение (более -250 \u20BD/т)',
      [ForecastTrend.Lateral]: 'Боковой тренд (+/-250 \u20BD/т)',
    };
    return description[
      this.instrument.forecast?.trend ?? ForecastTrend.Lateral
    ];
  }

  public get forecastColor(): string {
    return this.instrument.forecast?.trend ?? ForecastTrend.Lateral;
  }
}
